export const lowercase = (value) => {
	if (!value) return ''
	value = value.toString()
	return typeof value === 'string' ? value.toLowerCase() : value;
};
